<template>
  <div class="flex-row align-items-center p-0 gap16 stretch">
    <p class="has-text-size-14">
      <template v-if="!isBusiness">
        {{ $t("bnpl:psd2wrongData") }}
      </template>
      <template v-else>
        {{ $t("bnpl_b2b:psd2wrongData") }}
      </template>
    </p>
    <button
      id="bnpl_psd2_open_mistake_popup_button"
      class="linkButton has-text-size-14"
      @click="openMistakeFoundPopup"
    >
      <template v-if="!isBusiness">
        {{ $t("bnpl:psd2signWrongData") }}
      </template>
      <template v-else>
        {{ $t("bnpl_b2b:psd2signWrongData") }}
      </template><i class="pi pi-arrow-right" />
    </button>
  </div>
  <Popup
    v-if="showMistakeFoundPopup"
    @close="closeMistakeFoundPopup"
  >
    <div
      class="flex-column align-items-center gap24"
      style="width: 100%; max-width: 400px"
    >
      <template v-if="mistakeFoundPopupStatus === 'START'">
        <h2 class="h bold">
          <template v-if="!isBusiness">
            {{ $t("bnpl:psd2.mistake_found") }}
          </template>
          <template v-else>
            {{ $t("bnpl_b2b:psd2.mistake_found") }}
          </template>
        </h2>
        <p>
          <template v-if="!isBusiness">
            {{ $t("bnpl:psd2.send_correct_data-text") }}
          </template>
          <template v-else>
            {{ $t("bnpl_b2b:psd2.send_correct_data-text") }}
          </template>
        </p>
        <div class="flex-column gap12 stretch">
          <div class="inputField">
            <label class="p-caption bold">
              <template v-if="!isBusiness">{{ $t("bnpl:income") }}</template>
              <template v-else>{{ $t("bnpl_b2b:income") }}</template>
              <span
                class="bold"
                style="color: var(--systemError)"
              >*</span>
            </label>
            <input
              v-model="mistakeFoundForm.overrideSalary"
              class="textInput"
            >
          </div>
          <div class="inputField">
            <label class="p-caption bold">
              <template v-if="!isBusiness">{{ $t("bnpl:psd2.sum_of_monthly_payments") }}</template>
              <template v-else>{{ $t("bnpl_b2b:psd2.sum_of_monthly_payments") }}</template>
              <span
                class="bold"
                style="color: var(--systemError)"
              >*</span>
            </label>
            <input
              v-model="mistakeFoundForm.overrideLoans"
              class="textInput"
            >
          </div>
          <div class="inputField">
            <label class="p-caption bold">
              <template v-if="!isBusiness">{{ $t("bnpl:psd2.describe_the_problem") }}</template>
              <template v-else>{{ $t("bnpl_b2b:psd2.describe_the_problem") }}</template>
              <span
                class="bold"
                style="color: var(--systemError)"
              >*</span>
            </label>
            <textarea
              v-model="mistakeFoundForm.message"
              class="textInput"
            />
          </div>
          <button
            id="bnpl_psd2_send_override_button"
            class="btn btnL grow"
            @click="sendOverride"
          >
            <template v-if="!isBusiness">
              {{ $t("bnpl:send") }}
            </template>
            <template v-else>
              {{ $t("bnpl_b2b:send") }}
            </template>
          </button>
        </div>
      </template>
      <template v-else-if="mistakeFoundPopupStatus === 'SUCCESS'">
        <IllustrationsSuccess />
        <div class="flex-row justify-content-center stretch">
          <h2
            class="h bold"
            style="color: var(--systemSuccess)"
          >
            <template v-if="!isBusiness">
              {{ $t("bnpl:psd2mistake.success") }}
            </template>
            <template v-else>
              {{ $t("bnpl_b2b:psd2mistake.success") }}
            </template>
          </h2>
        </div>
      </template>
      <template v-else-if="mistakeFoundPopupStatus === 'FAIL'">
        <IllustrationsError />
        <div class="flex-row justify-content-center stretch">
          <h2
            class="h bold"
            style="color: var(--systemError)"
          >
            <template v-if="!isBusiness">
              {{ $t("bnpl:psd2mistake.fail") }}
            </template>
            <template v-else>
              {{ $t("bnpl_b2b:psd2mistake.fail") }}
            </template>
          </h2>
        </div>
      </template>
    </div>
  </Popup>
</template>

<script setup>
const showMistakeFoundPopup = ref(false);
const mistakeFoundPopupStatus = ref("START");

const props = defineProps({
  flow: {
    type: Object,
    required: true,
  },
});

// Fixed for the life of the component, like the mount that set it.
const isBusiness = props.flow.isBusiness;

const mistakeFoundForm = reactive({
  overrideSalary: 0,
  overrideLoans: 0,
  message: "",
});

function openMistakeFoundPopup() {
  showMistakeFoundPopup.value = true;
}

function closeMistakeFoundPopup() {
  showMistakeFoundPopup.value = false;
  mistakeFoundPopupStatus.value = "START";
}


async function sendOverride() {
  let request = {
    overrideSalary: mistakeFoundForm.overrideSalary,
    overrideLoans: mistakeFoundForm.overrideLoans,
    message: mistakeFoundForm.message,
  };
  try {
    // Which endpoint this reaches is the provider's business. Deciding it here
    // meant a business customer's report went to the consumer one, because the
    // branch asked the consumer aggregator setting either way.
    await props.flow.reportMistake(request);
    mistakeFoundPopupStatus.value = "SUCCESS";
  } catch (e) {
    mistakeFoundPopupStatus.value = "FAIL";
  }
}
</script>

<style scoped lang="scss">
.linkButton {
  font-size: 12px;
  color: var(--brandPrimary);
}

.linkButton.has-text-size-14 {
  font-size: 14px;
  color: var(--brandPrimary);
}
</style>